// extracted by mini-css-extract-plugin
export default {"addDeviceFamilyLink":"deviceFamiliesSelect__addDeviceFamilyLink-TL3FF","description":"deviceFamiliesSelect__description-bIXLV"};